// @ts-nocheck
import React, { Fragment } from 'react';
import { Platform } from 'react-native';
import { WebView } from 'react-native-webview';
import ChildPage from 'components/main/ChildPage';
import Loading from 'components/utility/Loading';
import { privacySections } from 'resources/data/text/toc';
import { ListSections, TextSections } from 'components/utility/TOC';
import { TOCList } from 'interfaces/page/SettingsInterfaces';
import { SizableText, H1, H3, ScrollView } from 'tamagui';
import { Center } from 'components/base/General';

const PrivacyRouter = () => {
  if (Platform.OS === 'web') {
    return <Privacy />;
  } else {
    return (
      <WebView
        startInLoadingState={true}
        renderLoading={() => <Loading />}
        originWhiteList={['*']}
        source={{
          uri: 'https://pandaist.com/privacy/',
        }}
        scalesPageToFit={true}
        mixedContentMode="always"
        allowsBackForwardNavigationGestures={true}
        scrollEnabled={true}
        directionalLockEnabled={false}
        style={{ backgroundColor: 'transparent' }}
      />
    );
  }
};

const Privacy = () => {
  return (
    <ChildPage py={'0'} bg={'white'}>
      <ScrollView
        _contentContainerStyle={{
          mb: 50,
          mt: 50,
          mr: 10,
          ml: 10,
        }}
      >
        <Center display="flex" gap={25} px={50} py={40}>
          <H1 textAlign="center" fontWeight="bold" fontSize="$5xl">
            PRIVACY POLICY
          </H1>

          <SizableText>Last updated 10/10/2022</SizableText>

          <SizableText>
            Thank you for choosing to be part of our community at Codexr, LLC ("
            <SizableText fontWeight="bold">Company</SizableText>
            ", “<SizableText fontWeight="bold">we</SizableText>”, “
            <SizableText fontWeight="bold">us</SizableText>”, or “
            <SizableText fontWeight="bold">our</SizableText>”). We are committed
            to protecting your personal information and your right to privacy.
            If you have any questions or concerns about our policy, or our
            practices with regards to your personal information, please contact
            us at contact@pandaist.com.
          </SizableText>

          {privacySections.map((section: TOCList, index: number) => (
            <Fragment key={index}>
              {typeof section.heading === 'undefined' ? null : (
                <H3 fontSize="xl">{section.heading}</H3>
              )}
              {typeof section.text === 'undefined' ? null : (
                <TextSections texts={section.text} />
              )}
              {typeof section.list === 'undefined' ? null : (
                <ListSections items={section.list} />
              )}
            </Fragment>
          ))}
        </Center>
      </ScrollView>
    </ChildPage>
  );
};

export default PrivacyRouter;
